import { Button } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";
import { memo } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TypographyStyled } from "../styles/DashBoard";

const AccountsChartTitleButton = ({ path, label }) => {
  const { push } = useHistory();

  return (
    <Button
      variant="text"
      color="primary"
      size="small"
      style={{
        padding: 0,
      }}
      endIcon={<OpenInNew />}
      onClick={() => {
        push(path);
      }}
    >
      <TypographyStyled variant="h2">{label}</TypographyStyled>
    </Button>
  );
};

export default memo(AccountsChartTitleButton);
